import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController, MenuController } from '@ionic/angular';
import { UserRoles } from './enums/user-roles';
import UserModel from './models/user.model';
import { AuthService } from './services/auth.service';
import { ComuniLocalService } from './services/comuni-local.service';
import { StorageService } from './services/storage.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  public appPages = [
    { title: 'Confrati/Soci', url: '/soci', icon: 'people', hide: true, adminOnly: false },
    // { title: 'Confrate/Socio', url: '/socio/2918', icon: 'person', hide: true, adminOnly: false },
    { title: 'Movimenti', url: '/movimenti/1', icon: 'bar-chart', hide: true, adminOnly: false },
    { title: 'Importi annuali', url: '/importiannuali', icon: 'stats-chart', hide: true, adminOnly: false },
    // { title: 'Quota annuale', url: '/quotaannuale', icon: 'business', hide: true, adminOnly: false },
    { title: 'Impostazioni', url: '/azienda', icon: 'settings', hide: true, adminOnly: false },
    { title: 'Reportistica', url: '/reports', icon: 'analytics', hide: true, adminOnly: true },
  ];

  public loggedUser = null;
  public cappella: string|null = null;
  public cappelle: Array<any> = [
    {
      key: 'cappella1',
      label: 'Cappella 1'
    },
    {
      key: 'cappella2',
      label: 'Cappella 2'
    }
  ];

  constructor(
    private router: Router,
    private loadingController: LoadingController,
    private menuController: MenuController,
    private authService: AuthService,
    private storageService: StorageService,
    private comuniLocalService: ComuniLocalService
  ) {}

  async ngOnInit() {
    this.authService.userObservable().subscribe((user: UserModel) => {
      this.loggedUser = user;
      this.updatePagesItemsVisibillity(user);
    });

    // Preload Comuni to increase performance
    await this.comuniLocalService.preload();

    // Set cappella
    this.cappella = this.storageService.getItem('currentCappella');
    if (!!this.cappella === false) {
      this.cappella = this.cappelle[0].key;
      this.storageService.setItem('currentCappella', this.cappella);
      window.location.reload();
    }

    await this.testServices();
  }

  updatePagesItemsVisibillity(user: UserModel|null) {
    for (const item of this.appPages) {
      if (!!user === false) {
        item.hide = true;
      } else if (item.adminOnly) {
        item.hide = (user.role !== UserRoles.Admin);
      } else {
        item.hide = false;
      }
    }
  }

  async logout() {
    const loading = await this.loadingController.create({ message: 'Operazione in corso...' });
    loading.present();
    const logoutResult = await this.authService.userLogout();
    loading.dismiss();

    if (!!logoutResult === false) { return; }

    await this.menuController.close();
    await this.router.navigate(['/login']);
  }

  async testServices() {

    // Generazione quote
    // const res = await this.movimentiService.generateQuotes(2021);
    // console.log('res->', res);

    // Comuni tutti
    // const comuniTutti = await this.comuniLocalService.list();
    // console.log('comuni tutti -> ', comuniTutti);

    // // Comuni filtrati
    // const comuniFiltrati = await this.comuniLocalService.get((item: Comune, index: number) => {
    //   let include = true;
    //   include = (include && item.citta === 'VIETRI DI POTENZA');
    //   return include;
    // });
    // console.log('comuni filtrati -> ', comuniFiltrati);

  }

  async cappellaChange($event: any) {
    this.cappella = $event.detail.value;
    this.storageService.setItem('currentCappella', this.cappella);
    window.location.reload();
  }

}
